import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";
import Toggle from "../../../components/Toggle";

export default function ConditiiStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <div style={{ width: "100%" }}>
        <Toggle
          label="Penalitati pentru incalcare"
          description="Include o clauza de penalitati pentru incalcarea obligatiei de confidentialitate"
          checked={!!data.penalitati}
          onChange={() => update("penalitati")(!data.penalitati)}
        />
      </div>

      {data.penalitati && (
        <>
          <InputField
            label="Suma penalitate"
            value={data.penalitateSuma}
            onChange={update("penalitateSuma")}
            placeholder="ex: 10000"
            type="number"
            required
            half
            error={errors.penalitateSuma}
          />
          <SelectField
            label="Moneda"
            value={data.penalitateMoneda}
            onChange={update("penalitateMoneda")}
            options={[
              { value: "RON", label: "RON" },
              { value: "EUR", label: "EUR" },
            ]}
            half
          />
        </>
      )}

      <SelectField
        label="Instanta competenta"
        value={data.instanta}
        onChange={update("instanta")}
        options={[
          { value: "dezvaluie", label: data.bilateral ? "La sediul/domiciliul Primei Parti" : "La sediul/domiciliul Partii care dezvaluie" },
          { value: "primeste", label: data.bilateral ? "La sediul/domiciliul Celei de-a Doua Parti" : "La sediul/domiciliul Partii care primeste" },
          { value: "bucuresti", label: "Tribunalul Bucuresti" },
        ]}
      />

      <InputField
        label="Data semnarii"
        value={data.dataSemnare}
        onChange={update("dataSemnare")}
        type="date"
        half
      />
    </div>
  );
}
